import { Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { RoleGuard } from '../../guards/role.guard';
import { HasLinksGuard } from '../../guards/has-links.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () => import('../template/template.component').then(m => m.TemplateComponent),
    children: [
      {
        path: 'p',
        pathMatch: 'full',
        redirectTo: 'p/~'
      },
      {
        path: 'p/:slug',
        canActivate: [HasLinksGuard],
        loadComponent: () => import('../iframe/slug-page.component').then(m => m.SlugPageComponent)
      },
      {
        path: 'iframe-pages',
        canActivate: [RoleGuard],
        loadComponent: () => import('../iframe-pages/iframe-page.component').then(m => m.IframePageComponent)
      },
      {
        path: 'users',
        canActivate: [RoleGuard],
        loadComponent: () => import('../users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'report-mailings',
        canActivate: [RoleGuard],
        loadComponent: () => import('../report-mailings/report-mailings.component').then(m => m.ReportMailingsComponent)
      },
      {
        path: 'navigation',
        canActivate: [RoleGuard],
        loadComponent: () => import('../navigation-links/navigation-links.component').then(m => m.NavigationLinksComponent)
      },
      { path: '', redirectTo: 'p/~', pathMatch: 'full' },
    ]
  },
  {
    path: 'no-access',
    pathMatch: 'full',
    loadComponent: () => import('../no-access/no-access.component').then(m => m.NoAccessComponent)
  },
  {
    path: 'redirect',
    redirectTo: 'iframe',
    pathMatch: 'full'
  }
];
